// Pur et sans dépendance Node : importable côté navigateur (le bouton SSO s'en sert
// pour choisir l'origine du retour OAuth). Ne rien importer ici depuis `ingress.ts`, qui
// tire `node:net` et casserait le bundle client.

export function isTailnetHost(hostname: string | null | undefined): boolean {
  if (!hostname) return false;
  const h = hostname.trim().toLowerCase().replace(/:\d+$/, '');
  return h.endsWith('.ts.net');
}
